import styled from "styled-components";

export const NotFoundSection = styled.div.attrs({
  className: "flex min-h-[70vh] items-center justify-center",
})``;

export const NotFoundSectionSecondary = styled.div.attrs({
  className: "brand-panel max-w-2xl text-center",
})``;

export const NotFoundEyebrowText = styled.p.attrs({
  className: "font-anonymous text-xs uppercase tracking-[0.35em] text-[var(--brand-highlight)]",
})``;

export const NotFoundPageHeading = styled.h1.attrs({
  className: "mt-4 text-4xl text-[var(--brand-ink)]",
})``;

export const NotFoundBodyText = styled.p.attrs({
  className: "mt-4 text-sm leading-7 text-[var(--brand-muted)]",
})``;

export const NotFoundPrimaryButton = styled.button.attrs({
  className:
    "mt-8 rounded-2xl bg-[var(--brand-accent)] px-5 py-3 text-sm font-medium text-white transition hover:bg-[var(--brand-accent-deep)]",
})``;
